<template>
  <div
    class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-[200] h-full w-full font-zona"
  >
    <div
      class="h-[90vh] w-full bg-white rounded p-5 m-5 space-y-5 overflow-x-scroll"
    >
      <div class="flex justify-end">
        <button
          @click="closeAnswers()"
          class="flex justify-center items-center bg-blue-200 h-8 w-8 rounded-full text-sm text-white hover:bg-blue-300"
        >
          <font-awesome-icon icon="fa-solid fa-x" />
        </button>
      </div>

      <div v-if="!isAnswerLoading && assessmentAnswer.length > 0">
        <div ref="pdfContent" class="space-y-5">
          <div class="flex justify-between">
            <p class="text-sm italic">
              Огноо: {{ assessmentResult.created_at.slice(0, 10) }}
            </p>
            <button></button>
          </div>
          <div
            class="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm bg-slate-100 p-4 rounded border border-slate-300"
          >
            <div class="space-x-1">
              <span class="font-semibold">Нийт хувь:</span>
              <span class="text-blue-600 font-bold">
                {{ assessmentResult.main_percentage }}%
              </span>
            </div>
            <div class="space-x-1">
              <span class="font-semibold">Нийт тийм (✓):</span>
              <span class="text-green font-bold">
                {{ assessmentResult.total_true }}
              </span>
            </div>
            <div class="space-x-1">
              <span class="font-semibold">Нийт үгүй (✗):</span>
              <span class="text-red-500 font-bold">
                {{ assessmentResult.total_false }}
              </span>
            </div>
            <div class="space-x-1">
              <span class="font-semibold">1-р бүлгийн хувь:</span>
              {{ assessmentResult.first_section_per }}%
            </div>
            <div class="space-x-1">
              <span class="font-semibold">2-р бүлгийн хувь:</span>
              {{ assessmentResult.second_section_per }}%
            </div>
            <div class="space-x-1">
              <span class="font-semibold">3-р бүлгийн хувь:</span>
              {{ assessmentResult.third_section_per }}%
            </div>
            <div class="space-x-1">
              <span class="font-semibold">4-р бүлгийн хувь:</span>
              {{ assessmentResult.fourth_section_per }}%
            </div>
            <div class="space-x-1">
              <span class="font-semibold">5-р бүлгийн хувь:</span>
              {{ assessmentResult.fifth_section_per }}%
            </div>
          </div>

          <table class="w-full text-xs">
            <thead class="bg-slate-300 text-black text-sm">
              <tr>
                <th class="border border-slate-300">№</th>
                <th class="border border-slate-300 uppercase">Асуулт</th>
                <th class="border border-slate-300">Тийм (1)</th>
                <th class="border border-slate-300">Үгүй (0)</th>
                <th class="border border-slate-300">
                  Нотлох эх үүсвэр байгаа эсэх
                </th>
                <th class="border border-slate-300">Нотлох эх үүсвэр</th>
                <th class="border border-slate-300">Тайлбар</th>
              </tr>
            </thead>

            <tbody>
              <template
                v-for="(answer, mIndex) in assessmentAnswer"
                :key="mIndex"
              >
                <tr
                  v-if="answer.pid === null"
                  class="bg-slate-300 text-black text-sm font-semibold"
                >
                  <td class="p-2 border border-slate-300">{{ answer.cid }}</td>
                  <td class="p-2 border border-slate-300 uppercase">
                    {{ answer.question }}
                  </td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                </tr>

                <tr
                  v-else-if="/^\d+\.\d+\.\d+$/.test(answer?.cid)"
                  class="bg-slate-100"
                >
                  <td class="p-2 border border-slate-300">{{ answer?.cid }}</td>
                  <td class="p-2 border border-slate-300">
                    {{ answer?.question }}
                  </td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                  <td class="border border-slate-300"></td>
                </tr>

                <tr v-else>
                  <td class="p-2 border border-slate-300">{{ answer.cid }}</td>
                  <td class="p-2 border border-slate-300">
                    {{ answer.question }}
                  </td>
                  <td
                    class="border border-slate-300"
                    :class="answer.answer === true ? 'text-green' : ''"
                  >
                    <div class="flex justify-center items-center">
                      {{ answer.answer === true ? "✓" : "" }}
                    </div>
                  </td>
                  <td
                    class="border border-slate-300"
                    :class="answer.answer === false ? 'text-red-500' : ''"
                  >
                    <div class="flex justify-center items-center">
                      {{ answer.answer === false ? "✗" : "" }}
                    </div>
                  </td>
                  <td
                    class="border border-slate-300"
                    :class="
                      answer.proof === true ? 'text-green' : 'text-red-500'
                    "
                  >
                    <div class="flex justify-center items-center">
                      {{
                        answer.proof === true
                          ? "✓"
                          : answer.proof === false
                          ? "✗"
                          : ""
                      }}
                    </div>
                  </td>
                  <td class="border border-slate-300">
                    <div
                      v-if="answer.proof_file"
                      class="flex justify-center items-center"
                    >
                      <a
                        :href="answer.proof_file"
                        target="_blank"
                        class="underline text-blue-500 cursor-pointer"
                        >Үзэх</a
                      >
                    </div>
                  </td>
                  <td class="border border-slate-300">{{ answer.comment }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="flex justify-center">
          <button
            @click="downloadPDF()"
            class="px-4 py-2 bg-blue-500 text-white rounded text-sm mt-5"
          >
            <font-awesome-icon icon="fa-solid fa-download" class="mr-1" />
            Хариултыг татах
          </button>
        </div>
      </div>

      <div
        v-else-if="!isAnswerLoading && assessmentAnswer.length === 0"
        class="flex justify-center items-center h-full text-xl text-slate-500 font-bold"
      >
        Хариулт олдсонгүй.
      </div>

      <div v-else class="flex justify-center items-center h-full">
        <spin-loading :color="'rgb(59 130 246)'" />
      </div>
    </div>
  </div>
</template>

<script>
import SpinLoading from "@/components/ui/SpinLoading.vue";
import clientInstance from "@/lib/clientInstance";
import { onMounted, ref } from "vue";
import html2pdf from "html2pdf.js";

export default {
  name: "MMAssessmentViewAnswer",
  components: {
    SpinLoading,
  },
  props: {
    answerId: Number,
    memberId: Number,
  },
  emits: ["closeAnswers"],
  setup(props, { emit }) {
    const closeAnswers = () => {
      emit("closeAnswers");
    };

    const isAnswerLoading = ref(false);
    const assessmentAnswer = ref([]);
    const assessmentResult = ref({});

    const fetchAssessmentAnswers = async () => {
      try {
        isAnswerLoading.value = true;
        const res = await clientInstance.get(
          `/get/member-answers?answerId=${props.answerId}&memberId=${props.memberId}`
        );
        if (res.status === 200) {
          assessmentAnswer.value = res.data.answer.answers;
          assessmentResult.value = res.data.answer.result;
        }
      } catch (err) {
        return err;
      } finally {
        isAnswerLoading.value = false;
      }
    };

    onMounted(() => {
      fetchAssessmentAnswers();
    });

    const pdfContent = ref(null);
    const downloadPDF = () => {
      const element = pdfContent.value;
      const opt = {
        margin: 0.5,
        filename: `ХУУ-өөрийн-үнэлгээ-${assessmentResult.value.created_at.slice(
          0,
          10
        )}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf().set(opt).from(element).save();
    };

    return {
      closeAnswers,
      assessmentAnswer,
      isAnswerLoading,
      assessmentResult,
      pdfContent,
      downloadPDF,
    };
  },
};
</script>
